// Inspiration from https://github.com/williamkapke/bson-objectid

const MACHINE_ID = Math.floor(Math.random() * 0xffffff);
let index = parseInt((Math.random() * 0xffffff) as any, 10);
const pid =
  (typeof process === "undefined" || typeof process.pid !== "number"
    ? Math.floor(Math.random() * 100000)
    : process.pid) % 0xffff;

function next() {
  return (index = (index + 1) % 0xffffff);
}

export function generateObjectIdString(time?: number): string {
  if (typeof time !== "number") {
    time = Date.now() / 1000;
  }

  time = parseInt(time as any, 10) % 0xffffffff;

  return hex(8, time) + hex(6, MACHINE_ID) + hex(4, pid) + hex(6, next());
}

function hex(length: number, n: any) {
  n = n.toString(16);
  return n.length === length ? n : "00000000".substring(n.length, length) + n;
}

export const createObjectID = generateObjectIdString;

/**
 * A 24-hex id that either ends the string or is followed by a non-hex character.
 * The lookahead is what keeps this safe: without it, `<24 hex><more hex>` would
 * be truncated to its first 24 characters, which is itself a valid id — silently
 * resolving to the *wrong* record.
 */
const objectIdPrefix = /^([0-9a-fA-F]{24})(?![0-9a-fA-F])/;

/**
 * Extracts a 24-hex ObjectId from a value that may carry junk appended by email
 * link rewriting — Safe-Links/scanner tokens, a concatenated URL, a stray quote.
 * That junk always starts with a non-hex character (`_`, `h`, `'`, `?`, `&`, `%`,
 * `>`), so the id survives as a prefix up to a non-hex boundary (CRMDEV-7168).
 *
 * Returns `null` when the value is not exactly 24 hex characters and has no
 * non-hex boundary after the 24th — a truncated id, or extra hex that makes the
 * intended id ambiguous. Such a value is unrecoverable and must not be looked
 * up: dead-lettering the message is correct, guessing a neighbouring id is not.
 */
export function parseObjectIdString(value: string | null | undefined): string | null {
  if (!value) {
    return null;
  }

  return objectIdPrefix.exec(value.trim())?.[1] ?? null;
}
